import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { toast } from "sonner";
import { TCMLogo } from "../components/TCMLogo";

export default function MyTripsPage() {
  const { API, authHeaders, user, logout } = useAuth();
  const nav = useNavigate();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/trips`, { headers: authHeaders })
      .then((r) => setTrips(r.data))
      .catch(() => toast.error("Failed to load trips"))
      .finally(() => setLoading(false));
  }, []);

  const active = trips.filter((t) => !t.archived);
  const archived = trips.filter((t) => t.archived);

  return (
    <div className="min-h-screen px-6 py-10 max-w-3xl mx-auto" data-testid="my-trips-page">
      <div className="flex justify-between items-center mb-8">
        <div className="flex items-center gap-6">
          <TCMLogo size="md" />
          <div>
            <p className="tcm-eyebrow">Welcome, {user?.full_name}</p>
            <h1 className="font-display text-4xl mt-2">My Trips</h1>
          </div>
        </div>
        <button data-testid="logout-btn" onClick={() => { logout(); nav("/"); }} className="tcm-eyebrow underline decoration-[#C9A961] underline-offset-4">Sign out</button>
      </div>
      <hr className="tcm-gold-rule mb-10" />

      {loading && <p className="text-center py-16 tcm-eyebrow">Loading...</p>}
      {!loading && trips.length === 0 && (
        <div className="tcm-double-frame">
          <div className="tcm-inner p-10 text-center">
            <p className="font-display text-2xl">No trips yet</p>
            <p className="mt-3 text-sm text-[color:var(--tcm-navy-70)]">Your concierge will curate one soon.</p>
          </div>
        </div>
      )}

      {active.length > 0 && (
        <>
          <p className="tcm-eyebrow mb-4">Upcoming & Current</p>
          <div className="space-y-6 mb-12">
            {active.map((t) => <TripCard key={t.id} t={t} onClick={() => nav(`/trips/${t.id}`)} />)}
          </div>
        </>
      )}

      {archived.length > 0 && (
        <>
          <p className="tcm-eyebrow mb-4">Past trips</p>
          <div className="space-y-6">
            {archived.map((t) => <TripCard key={t.id} t={t} archived onClick={() => nav(`/trips/${t.id}`)} />)}
          </div>
        </>
      )}

      <div className="mt-16 pt-6 border-t border-[color:var(--tcm-navy-15)] text-center">
        <a data-testid="back-to-marketing-trips" href="https://www.the-curated-mile.com"
           className="tcm-eyebrow underline decoration-[#C9A961] underline-offset-4">
          ← the-curated-mile.com
        </a>
      </div>
    </div>
  );
}

function TripCard({ t, archived, onClick }) {
  return (
    <button data-testid={`trip-card-${t.id}`} onClick={onClick} className="block w-full text-left">
      <div className="tcm-double-frame hover:opacity-80 transition-opacity">
        <div className="tcm-inner p-6">
          <div className="flex justify-between items-start">
            <div>
              <p className="tcm-eyebrow">{t.currency} · {archived ? "Archived" : t.status}</p>
              <h3 className="font-display text-3xl mt-2">{t.destination}</h3>
              <p className="mt-2 text-sm text-[color:var(--tcm-navy-70)]">{t.start_date} → {t.end_date}</p>
            </div>
            <span className="tcm-eyebrow">→</span>
          </div>
        </div>
      </div>
    </button>
  );
}
